import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { tap, map } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(
    private httpClient: HttpClient
  ) { }

  downloadFile (url: string, nombre: string): Observable<any> {
    return this.httpClient.get(environment.hostBack + url, {responseType: 'blob'})
    .pipe(
      tap(content => {
        saveAs(content, nombre)
      }),
      map(() => true)
    )
  }

    getFileBlob (url: string) {
        return new Promise<any>((resolve, reject) => {
            this.httpClient.get(environment.hostBack + url, {responseType: 'blob'})
            .subscribe({
                next: (res) => resolve(res),
                error: (err) => reject(err)
            });
        });
    }

    getFileBase64 (url: string) {
        return new Promise<any>((resolve, reject) => {
            this.httpClient.get(environment.hostBack + url, {responseType: 'blob'})
            .subscribe({
                next: async (res) => {
                    var data = await this.blobToBase64(res);
                    resolve((data as string).replace(/^data:.+;base64,/, ''));
                },
                error: (err) => reject(err)
            });
        });
    }

    blobToBase64 = (blob: Blob): Promise<string | ArrayBuffer> => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        return new Promise(resolve => {
            reader.onloadend = () => {
                resolve(reader.result);
            };
        });
    };
}
